import { StackedCellText } from '@/components/common/DataTable';
import { StatusBadge } from '@/components/common/StatusBadge';
import { EMPTY_VALUE } from '@/constants/app.constants';
import { VERIFY_STATUS } from '@/features/billing/constants/billing.constants';
import { APPROVAL_STATUS_TONE, type StatusColorTone } from '@/styles/statusColors';

interface ApprovalBadge {
  label: string;
  tone: StatusColorTone;
}

interface DcrApproveStatusCellProps {
  approveTypeNo: number;
  approveType: string | null;
  isVerify: number;
}

function getApprovalBadge(approveTypeNo: number, approveType: string | null): ApprovalBadge {
  if (approveTypeNo === VERIFY_STATUS.VERIFIED) {
    return { label: 'Approved', tone: APPROVAL_STATUS_TONE.approved };
  }
  if (approveTypeNo === VERIFY_STATUS.REJECTED) {
    return { label: 'Rejected', tone: APPROVAL_STATUS_TONE.rejected };
  }
  if (approveTypeNo === VERIFY_STATUS.PENDING) {
    return { label: 'Pending', tone: APPROVAL_STATUS_TONE.pending };
  }
  return { label: approveType ?? EMPTY_VALUE, tone: 'neutral' };
}

export function DcrApproveStatusCell({
  approveTypeNo,
  approveType,
  isVerify,
}: DcrApproveStatusCellProps) {
  const badge = getApprovalBadge(approveTypeNo, approveType);

  return (
    <StackedCellText
      primary={<StatusBadge tone={badge.tone}>{badge.label}</StatusBadge>}
      secondary={isVerify === VERIFY_STATUS.VERIFIED ? 'Verified' : 'Not verified'}
      isCentered
    />
  );
}
